import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EcoImg from 'eco-design/base/eco-img';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function OtherFeatures({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const IS_EU = ['eu', 'de', 'es', 'fr', 'it', 'uk'].includes(locale);
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_ROW = ['au', 'mx', 'br', 'kr', 'ph', 'za', 'sa'].includes(locale);

    return (
        <div
            className={`${css.OtherFeatures} OtherFeatures GtmModuleData-section`}
            data-section-id={css.OtherFeatures}
            data-section-title={['au'].includes(locale) ? t('delta2.aniG_msg7') : t('delta2.aniM_msg1')}
        >
            {!['au'].includes(locale) && (
                <div className="s-box light-box">
                    <div className="f-img">
                        <div className="img-wrapper">
                            <EFPic name={['protable_light.webp', 'protable_light.png']} />
                        </div>
                    </div>
                    <div className="f-text">
                        <div className="f-title">{t('delta2.aniM_msg1')}</div>
                        <div className="f-des">{t('delta2.aniM_msg2')}</div>
                    </div>
                </div>
            )}
            {['au'].includes(locale) && (
                <div className="s-box good-design">
                    <div className="f-img">
                        <div className="img-wrapper">
                            <EFPic name={['good_design.png', 'good_design.png']} />
                        </div>
                    </div>
                    <div className="f-text">
                        <div className="f-title">{t('delta2.aniG_msg7')}</div>
                        <div className="f-des">{t('delta2.good_design')}</div>
                    </div>
                </div>
            )}
            <div className="s-box bag-box">
                <div className="f-img">
                    <div className="img-wrapper">
                        <EFPic name={['bag.webp', 'bag.jpg']} />
                    </div>
                </div>
                <div className="f-text">
                    <div className="f-title" style={locale === 'fr' ? { fontSize: '0.33rem' } : {}}>
                        {t('delta2.aniM_msg6')}
                    </div>
                    <div className="f-des">{t('delta2.aniM_msg7')}</div>
                </div>
            </div>

            <div className="s-box waranty-box">
                <div className="f-img">
                    <div className="img-wrapper">
                        <EFPic name={['11Easy controls.webp', '11Easy controls.png']} />
                    </div>
                </div>
                <div className="f-text">
                    <div className="f-title">{t('delta2.aniM_msg3')}</div>
                    <div className="f-des">{t('delta2.aniM_msg4')}</div>
                </div>
                <div className="text-2">
                    <div className="f-num">{t('delta2.aniM_num1')}</div>
                    <div className="f-numdes">{t('delta2.aniM_msg5')}</div>
                </div>
            </div>

            <div className="s-box cable-box">
                <p className="title">{t('delta2.aniM_msg8')}</p>
                <p className="includes">{t('delta2.aniM_msg10')}</p>
                <div className="f-img">
                    <div className="img-wrapper">
                        {IS_EU || IS_NA || IS_ROW ? (
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1755481187230/delta2_eu.jpg" />
                        ) : (
                            <EFPic name={['2.webp', '2.png']} />
                        )}
                    </div>
                </div>
                <p className="desc">{t('delta2.aniM_msg9')}</p>
            </div>
        </div>
    );
}
